import { React, useState } from "react";
import { useUpdateAvatar } from "../../../hooks/apis/user";

function Avatar_user(props) {
  const { mutate, isLoading, isSuccess } = useUpdateAvatar();

  //Convert Bytes to KiB
  function formatBytes(bytes, decimals = 2) {
    if (!+bytes) return "0 Bytes";

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = [
      "Bytes",
      "کیلوبایت",
      "مگابایت",
      "GiB",
      "TiB",
      "PiB",
      "EiB",
      "ZiB",
      "YiB",
    ];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  }

  const [selectedFile, setSelectedFile] = useState();
  const [isFilePicked, setIsFilePicked] = useState(false);

  const changeHandler = (event) => {
    setSelectedFile(event.target.files[0]);
    setIsFilePicked(true);
  };

  const HandleUpload = () => {
    if (isFilePicked && selectedFile.size < 2097152) {
      mutate(selectedFile);
    } else {
      //Show alert
      alert("لطفا یک تصویر برای آپلود انتخاب کنید");
    }
  };

  return (
    <>
      <div className={props.showPopup ? "avatar_modal active" : "avatar_modal"}>
        <h2 className="text-center text-white fs-5 mb-3">
          انتخاب تصویر پروفایل
        </h2>
        <input
          className="form-control"
          type="file"
          name="avatar_file"
          id="avatar_file"
          onChange={changeHandler}
          accept="image/png, image/jpeg"
        />
        {isFilePicked ? (
          <div className="d-flex align-item-center justify-content-between w-100 text-white">
            <p style={{ marginBottom: "0px", fontSize: "12px" }}>
              فرمت تصویر: {selectedFile.type}
            </p>
            <p style={{ marginBottom: "0px", fontSize: "12px" }}>
              حجم تصویر: {formatBytes(selectedFile.size)}
            </p>
          </div>
        ) : (
          ""
        )}
        <input
          type="button"
          id="submit_avatar"
          name="submit_avatar"
          value="آپلود تصویر"
          onClick={HandleUpload}
        />
      </div>
    </>
  );
}

export default Avatar_user;
